import { BENCHMARK_ORG_SIZE_KEYS, metricNames } from '@linearb/linjs-common';
import { EMPTY_VALUE } from 'common/constants/constants';
import {
  convertMinutesToDisplayableTime,
  getDefaultFormatter
} from 'common/utils/time.utils';
import { getDurationLevels } from '@linearb/linui-utils';
import { compareMetricToIndustryStandard } from 'common/utils/utils';
import _ from 'lodash';

const pipelineTimeUnitToTextSizeMap = {
  Months: 'huge',
  Days: 'huge',
  'Min.': 'x-x-x-large',
  Hours: 'x-x-x-x-large'
};

export const mapCycleTimeStatisticsToPipelineMilestones = (
  {
    [metricNames.TIME_TO_PR]: timeToPr = EMPTY_VALUE,
    [metricNames.TIME_TO_REVIEW]: timeToReview = EMPTY_VALUE,
    [metricNames.REVIEW_TIME]: timeToMerged = EMPTY_VALUE,
    [metricNames.TIME_TO_PROD]: timeToProd = EMPTY_VALUE
  } = {},
  { first_commit, pr_issued, pr_reviewed, pr_merged, isV2 } = {},
  metricsCalculationConfig = {},
  benchmarkOrgSize = BENCHMARK_ORG_SIZE_KEYS.all
) => {
  return [
    {
      title: 'First Commit',
      value: timeToPr,
      metricName: metricNames.TIME_TO_PR,
      tooltip: first_commit
    },
    {
      title: 'PR Issued',
      value: timeToReview,
      metricName: metricNames.TIME_TO_REVIEW,
      tooltip: pr_issued
    },
    {
      title: 'PR Review Started',
      value: timeToMerged,
      metricName: metricNames.REVIEW_TIME,
      tooltip: pr_reviewed
    },
    {
      title: 'PR Merged',
      value: timeToProd,
      metricName: metricNames.TIME_TO_PROD,
      tooltip: pr_merged
    }
  ].map(({ value, metricName, title, tooltip }) => {
    const { roundedInMinutes, label } = convertMinutesToDisplayableTime({
      minutes: value
    });

    const stringValue = getDurationLevels({
      minutes: value,
      ignoreZeros: true,
      format: isV2
        ? getDefaultFormatter({
            minutes: value,
            daysUnit: `<span class='smallUnit'>d</span>`,
            hoursUnit: `<span class='smallUnit'>h</span>`,
            minutesUnit: `<span class='smallUnit'>m</span>`,
            yearsUnit: `<span class='smallUnit'>y</span>`
          })
        : getDefaultFormatter({ minutes: value })
    });
    const { metricsCalculationStrategy } = metricsCalculationConfig;
    const { color, label: stateText } = compareMetricToIndustryStandard(
      metricName,
      _.isNumber(value) ? value : null,
      metricsCalculationStrategy,
      benchmarkOrgSize
    );

    return {
      tooltip,
      title,
      color,
      stateText,
      roundedInMinutes,
      value: _.isNumber(value) ? stringValue : '',
      titleSize: pipelineTimeUnitToTextSizeMap[label] || '',
      subTitle: _.isNumber(value) ? label : '',
      rawValue: _.isNumber(value) ? value : null
    };
  });
};
